import classnames from "classnames";
import { componentStyles } from "./responsive-banner.scss";

const ResponsiveBanner = (props) => {
  const {
    title,
    description,
    imageLink,
    titleTagComponent: TitleTag,
    descriptionTagComponent: DescriptionTag,
    color,
    isMobileBanner
  } = props;

  return (
    <div className={classnames("responsive-banner-component", color, { "mobile-banner": isMobileBanner })}>
      <div className="content-wrapper">
        <TitleTag className="title"> {title} </TitleTag>
        {!isMobileBanner && <DescriptionTag className="description"> {description}</DescriptionTag>}
      </div>
      {imageLink && (
        <div className="image-wrapper">
          <img className="banner-image" src={imageLink} />
        </div>
      )}
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default ResponsiveBanner;

ResponsiveBanner.defaultProps = {
  titleTagComponent: "div",
  descriptionTagComponent: "div",
  color: "iris",
  isMobileBanner: false // not using isMobileOrTablet since we want this behaviour in every screen under 768px
};
